module.exports = __webpack_public_path__ + "static/media/Jaime Lannister.17bcbf3a.jpg";